// -------------------首页底部折叠--------------------
document.addEventListener("DOMContentLoaded", function () {
  // 只在手机端执行
  if (window.innerWidth <= 768) {
    const footerButtons = document.querySelectorAll(".newfooterbtn");

    footerButtons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        const widget = btn.closest(".widget");

        // 切换 open 类
        widget.classList.toggle("open");
      });
    });
  }
});

// -----------------------首页评分去掉“reviews”，并给数量添加（）------------------
// document.addEventListener('DOMContentLoaded', function () {

//   function updateJudgeReview() {

//     document.querySelectorAll(' .featured-collection__collection .columns .jdgm-prev-badge__text').forEach(function (el) {

//       let text = el.textContent.trim();

//       let match = text.match(/(\d+)\s*reviews?/i);

//       if (match) {
//         el.textContent = '(' + match[1] + ')';
//       }

//     });

//   }


//   // 页面第一次执行
//   updateJudgeReview();


//   // 监听 Judge.me 后续重新渲染
//   const observer = new MutationObserver(function () {
//     updateJudgeReview();
//   });


//   observer.observe(document.body, {
//     childList: true,
//     subtree: true,
//     characterData: true
//   });

// });

// ---------------详情页评论图当打关闭后页面滚动问题-------------------
(function () {
  // 防止脚本重复执行
  if (window.__jdgmReviewScrollFixInitialized) return;
  window.__jdgmReviewScrollFixInitialized = true;

  let popupOpen = false;
  let restoreTimer = null;

  const html = document.documentElement;
  const body = document.body;

  function disableSmoothScroll() {
    html.style.setProperty(
      'scroll-behavior',
      'auto',
      'important'
    );

    body.style.setProperty(
      'scroll-behavior',
      'auto',
      'important'
    );
  }

  function restoreSmoothScroll() {
    html.style.removeProperty('scroll-behavior');
    body.style.removeProperty('scroll-behavior');
  }

  // Judge.me 评论图片点击
  document.addEventListener(
    'click',
    function (event) {
      const link = event.target.closest(
        'a.jdgm-rev__pic-link'
      );

      if (!link) return;

      // 清除之前的恢复计时器
      clearTimeout(restoreTimer);

      // Popup 打开前就关闭 smooth scroll
      disableSmoothScroll();

      console.log(
        '[Judge.me] smooth scroll disabled'
      );
    },
    true
  );

  // 监听 Judge.me Popup 状态
  const observer = new MutationObserver(function () {
    const isOpen =
      body.classList.contains('jm-mfp-is-open');

    // Popup 打开
    if (isOpen) {
      popupOpen = true;

      // 防止 Judge.me 打开过程中其他代码覆盖
      disableSmoothScroll();

      return;
    }

    // Popup 刚刚关闭
    if (popupOpen) {
      popupOpen = false;

      console.log(
        '[Judge.me] popup closed'
      );

      /*
       * Judge.me 关闭 Popup 后还会执行
       * afterClose / scroll restoration。
       *
       * 所以这里不要立即恢复 smooth，
       * 给 Judge.me 留一点时间完成关闭流程。
       */
      clearTimeout(restoreTimer);

      restoreTimer = setTimeout(function () {
        restoreSmoothScroll();

        console.log(
          '[Judge.me] smooth scroll restored'
        );
      }, 500);
    }
  });

  observer.observe(body, {
    attributes: true,
    attributeFilter: ['class']
  });
})();


// ---------------img link模块滑动模式下拖拽功能--------------
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.NewImgoverbtn .NewImgBox').forEach(function (slider) {
      let isDragging = false;
      let startX = 0;
      let startScrollLeft = 0;
      let hasMoved = false;

      slider.addEventListener('mousedown', function (e) {
        isDragging = true;
        hasMoved = false;

        startX = e.pageX - slider.offsetLeft;
        startScrollLeft = slider.scrollLeft;

        slider.style.cursor = 'grabbing';

        e.preventDefault();
      });

      slider.addEventListener('mousemove', function (e) {
        if (!isDragging) return;

        const x = e.pageX - slider.offsetLeft;
        const distance = x - startX;

        if (Math.abs(distance) > 5) {
          hasMoved = true;
        }

        slider.scrollLeft = startScrollLeft - distance;
      });

      slider.addEventListener('mouseup', function () {
        isDragging = false;
        slider.style.cursor = 'grab';
      });

      slider.addEventListener('mouseleave', function () {
        isDragging = false;
        slider.style.cursor = 'grab';
      });

      // 阻止拖动后的a标签跳转
      slider.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function (e) {
          if (hasMoved) {
            e.preventDefault();
          }
        });
      });
    });
  });